module.exports = __webpack_public_path__ + "img/gf-pattern.775297de.svg";